import { render, staticRenderFns } from "./dailyJournalVoids.vue?vue&type=template&id=990bcf00&"
import script from "./dailyJournalVoids.vue?vue&type=script&lang=js&"
export * from "./dailyJournalVoids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports